import type { Reducer } from 'redux';

import type { SessionUpdateWebHostAction } from '../../../domains/session/actions.types';
import type { SessionConfigureAction } from '../../../domains/sessionConfigure/actions.types';

import type { Hosts } from './types';

export type SessionAction = SessionConfigureAction | SessionUpdateWebHostAction;

const initialState: Hosts = {
  api: '',
  broadcast: '',
  ecs: '',
  graphql: '',
  legacy: '',
  msGraph: '',
  ocv: '',
  substrate: '',
  suiteHeader: '',
  telemetry: '',
  tenor: '',
  thumbnails: '',
  thumbnailsEngage: '',
  translate: '',
  web: '',
  designerApp: '',
  designerMiniApp: '',
  designerAppService: '',
  shellSuiteHeader: '',
};

const stateWithUpdatedWebHost = (state: Hosts, action: SessionUpdateWebHostAction) => ({
  ...state,
  web: action.payload,
});

const reducer: Reducer<Hosts, SessionAction> = (state = initialState, action) => {
  switch (action.type) {
    case 'SESSION.CONFIGURE':
      return action.payload.hosts;
    case 'SESSION.UPDATE_WEB_HOST':
      return stateWithUpdatedWebHost(state, action);
    default:
      return state;
  }
};

export default reducer;
